// extracted by mini-css-extract-plugin
module.exports = {"container":"Loader_container__tRiVv","loader":"Loader_loader__2IgbZ","spinanimation":"Loader_spinanimation__3hGGI"};